import { render } from "./GetLogsButton.vue?vue&type=template&id=65b916c6"
import script from "./GetLogsButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GetLogsButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/labelinsight-products/components/GetLogsButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65b916c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65b916c6', __exports__)) {
    api.reload('65b916c6', __exports__)
  }
  
  module.hot.accept("./GetLogsButton.vue?vue&type=template&id=65b916c6", () => {
    api.rerender('65b916c6', render)
  })

}


export default __exports__